import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)
import Page from 'Scripts/classes/Page'

export default class Metier extends Page {
  constructor() {
    super('metiers', {
      container: '.metier',
      // customScroller: scroller,
      elements: {
        metierItems: '.metier__item',
        metierWrapper: '.metier__wrapper',
      },
    })

    // this.locoScroller = scroller
    const isTouchDevice = document.documentElement.classList.contains('isTouchDevice')
    //Methods
    // this.locoScroller && this.smoothScrollTrigger(this.locoScroller)
    this.elements.metierItems && !isTouchDevice && this.initScrollTrigger()
  }

  initScrollTrigger() {
    // ScrollTrigger.refresh()
    const length = this.elements.metierItems.length - 1
    const spacer = 50
    // const initPos = window.innerHeight / 5
    const initPos = 0
    let margin = 0

    this.elements.metierItems.forEach((metier, index) => {
      margin += spacer
      //
      gsap.to(metier, {
        scale: 1 - (length - index) * 0.025,
        // y: -(length - index) * 15,
        scrollTrigger: {
          trigger: metier,
          scrub: 3,
          pin: true,
          pinSpacing: false,
          start: `0% ${initPos + spacer * index}`,
          // end: () => this.elements.metierWrapper.clientHeight - (initPos),
          end: () => this.elements.metierWrapper.clientHeight,

          markers: false,
          anticipatePin: 1, //To resolve pin jumping
          preventOverlaps: true,
          fastScrollEnd: true,
        },
      })
    })

    //
    this.elements.metierWrapper.style.marginBottom = `${margin + 250}px`
  }

  // smoothScrollTrigger(scroll) {

  //   scroll.on("scroll", () => ScrollTrigger.update())
  //   //
  //   ScrollTrigger.scrollerProxy("[data-scroll-container]", {
  //     scrollTop(value) {
  //       return arguments.length ? scroll.scrollTo(value, 0, 0) : scroll.scroll.instance.scroll.y;
  //     }, // we don't have to define a scrollLeft because we're only scrolling vertically.
  //     getBoundingClientRect() {
  //       return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
  //     },
  //     // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
  //     pinType: document.querySelector("[data-scroll-container]").style.transform ? "transform" : "fixed"
  //   })

  //   //
  //   ScrollTrigger.defaults({
  //     scroller: document.querySelector('[data-scroll-container]'),
  //   })
  //   // each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll.
  //   ScrollTrigger.addEventListener('refresh', () => scroll.update())

  //   // after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
  //   ScrollTrigger.refresh()

  // }

  /**
   * Animations.
   */
  show() {
    return super.show()
  }

  hide() {
    return super.hide()
  }

  onResize() {
    // console.log('onResize')
    return super.onResize()
  }
}
